import {Component, computed, input, InputSignal, output, OutputEmitterRef} from '@angular/core';
import {
  MatCell,
  MatCellDef,
  MatColumnDef,
  MatHeaderCell,
  MatHeaderCellDef,
  MatHeaderRow,
  MatHeaderRowDef,
  MatRow,
  MatRowDef,
  MatTable
} from "@angular/material/table";
import {TranslatePipe} from "@ngx-translate/core";
import {RecordingSegmentView} from "../recording-segment.types";
import {MatIcon} from "@angular/material/icon";
import {MatIconButton} from "@angular/material/button";
import {NgClass} from "@angular/common";
import {msToTimecode} from "../../../object-edit/edit-field-timecode/timecode.utils";
import {RouterLink} from "@angular/router";
import {objectTypeToMatSymbol} from "../../../shared/material-icons";
import {compareRecordingSegments} from "../../../core/definitions/recording";

@Component({
  selector: 'app-recording-segment-table',
  imports: [
    MatCell,
    MatCellDef,
    MatColumnDef,
    MatHeaderCell,
    MatHeaderRow,
    MatHeaderRowDef,
    MatRow,
    MatRowDef,
    MatTable,
    TranslatePipe,
    MatHeaderCellDef,
    MatIcon,
    MatIconButton,
    NgClass,
    RouterLink
  ],
  templateUrl: './recording-segment-table.component.html',
  styleUrl: './recording-segment-table.component.scss',
})
export class RecordingSegmentTableComponent {
  displayedColumns = [
    'playback',
    'index',
    'name',
    'description',
    'start',
    'end',
    'duration',
    'actions',
  ];

  segments: InputSignal<RecordingSegmentView[]> = input([]);
  isPlaying: InputSignal<boolean> = input(false);
  activeSegmentIds: InputSignal<string[]> = input<string[]>([]);
  disabled: InputSignal<boolean> = input(false);

  segmentPlayClicked: OutputEmitterRef<string> = output<string>();

  readonly orderedSegments = computed(() =>
    this.segments()
      .slice()
      .sort((a, b) =>
        compareRecordingSegments(a, b) ||
        a.end - b.end ||
        a.artifact_id.localeCompare(b.artifact_id)
      )
  );

  getIsActiveSegment(artifactId: string): boolean {
    return this.activeSegmentIds().includes(artifactId);
  }

  getSegmentDuration(segment: RecordingSegmentView): number {
    return Math.max(0, segment.end - segment.start);
  }

  onPlayClicked(segmentId: string) {
    if (this.disabled()) {
      return;
    }
    this.segmentPlayClicked.emit(segmentId);
  }

  protected readonly msToTimecode = msToTimecode;
  protected readonly objectTypeToMatSymbol = objectTypeToMatSymbol;
}
